export class GoogleAnalyticsEventDto {
  public hitType = 'event';

  public event: string;
  public category: string;
  public action: string;
  public label?: string;
  public location?: string;
  public value?: number;

  constructor(
    event: string,
    category: string,
    action: string,
    label?: string,
    location?: string,
    value?: number
  ) {
    this.event = event;
    this.category = category;
    this.action = action;
    this.label = label;
    this.location = location;
    this.value = value;
  }
}
